import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { getStoredFlavor } from '../../base/package/util/flavor';
import style from './ui-build-info.css?inline';

const CName = 'ui-build-info';

@customElement(CName)
export class UIBuildInfo extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) commit = '';
  @property({ type: Boolean }) showCommit = false;
  @property({ type: String }) timeStamp = '';
  @property({ type: String }) version = '';

  @state() private _showDetails = false;

  render() {
    // Check if version is a commit hash: 7 or more hex chars; Or use v prefix
    const version = this.version.trim();
    const isCommitHash = /^[0-9a-f]{7,}$/i.test(version);
    const versionPrefix = /^\d/.test(version) ? 'v' : '';
    const prefix = isCommitHash ? '' : versionPrefix;

    const details = html`${this._showDetails ? this._longVersion() : this._shortVersion()}`;

    let className = 'version';
    if (window.$app.appConfig.iOS26FixEnabled) {
      className = `${className} ios26-fix`;
    }

    return html`
      <span @click=${this._toggleDetails} class=${className}>
        ${prefix}${details}${this._renderFlavor()}
      </span>
    `;
  }

  private _renderFlavor() {
    const storedFlavor = getStoredFlavor();
    if (!storedFlavor?.flavor) {
      return nothing;
    }
    return `• Flavor: ${storedFlavor.flavor}`;
  }

  private _shortVersion() {
    return `${this.version.length > 12 ? this.version.slice(0, 7) : this.version}`;
  }

  private _shortHash() {
    return `${this.commit.length > 12 ? this.commit.slice(0, 7) : this.commit}`;
  }

  private _longVersion() {
    return this.showCommit
      ? html`${this.version} • ${this.timeStamp} • <span id="commit">${this._shortHash()}</span>`
      : `${this.version} • ${this.timeStamp}`;
  }

  private _toggleDetails() {
    this._showDetails = !this._showDetails;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIBuildInfo;
  }
}
